var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"20px"}},[_c('pagination-table',{attrs:{"data":_vm.revertTurbineTypeList,"columns":_vm.columns,"loader":_vm.getTurbineTypeList,"async":true,"pageSizes":[20],"colCustom":_vm.colCustom}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }